import { render, staticRenderFns } from "./ProductHistory.vue?vue&type=template&id=786a0578&scoped=true"
import script from "./ProductHistory.vue?vue&type=script&lang=js"
export * from "./ProductHistory.vue?vue&type=script&lang=js"
import style0 from "./ProductHistory.vue?vue&type=style&index=0&id=786a0578&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "786a0578",
  null
  
)

export default component.exports